<div class="switch-view-container">
  <div
    (click)="fileInput.click()"
    (fileDropped)="uploadFile($event, fileInput)"
    appDragAndDrop
    class="upload-file-container uk-flex uk-flex-column uk-flex-middle uk-flex-center uk-margin">
    <fa-icon icon="file-upload" size="2x"></fa-icon>
    <div i18n="@@DropFileHere">Drop file here or click to upload.</div>
    <input #fileInput (change)="uploadFile($any($event.target).files, fileInput)" hidden id="file-upload" type="file" />
  </div>

  <div class="table-container uk-margin uk-flex uk-flex-column">
    <div *ngFor="let file of files" class="uk-flex uk-flex-middle admin-file">
      <fa-icon [icon]="['far', 'file']" size="2x" class="file-icon"></fa-icon>
      <span>{{ file.description }}</span>
      <app-download-file [url]="file.file"></app-download-file>
      <fa-icon (click)="deleteAdminFile(file.id)" [icon]="['far', 'trash-alt']" class="pointer uk-margin-small-left"></fa-icon>
    </div>
  </div>
</div>
